import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import { resources } from './locales';

i18n.use(initReactI18next).init({
  resources,
  lng: 'uk', // Set the initial language
  fallbackLng: 'uk', // Fallback language if translation key is missing in current language
  interpolation: {
    escapeValue: false // Not needed for React as it escapes by default
  }
});

export default i18n;
